import { Flex } from '@/_components/Flex';
import { Shimmer } from '@/_components/Shimmer';
import { FC } from 'react';

export const ChatItemLoading: FC = () => {
  return (
    <Flex padding={6} gap={4}>
      <Shimmer height={32} width={32} isRound={true} />
      <Flex isColumn={true} gap={6} isFullWidth={true}>
        <Flex isBetween={true} gap={8}>
          <Shimmer height={16} width={160} />
          <Shimmer height={12} width={32} />
        </Flex>
        <Flex gap={2} isColumn={true}>
          <Shimmer height={12} width={80} />
        </Flex>
      </Flex>
    </Flex>
  );
};
